import React from "react";
import { Table, Container, Row, Col, Card } from "react-bootstrap";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { FaFilePdf, FaPlus, FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

// Registra as fontes necessárias
pdfMake.vfs = pdfFonts.vfs

const RelatorioInventarioCliente = ({ filtro, dataHora, dados, setShowForm, setShowRelatorio }) => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/home");
  };

  const handleForm = () => {
    setShowForm(true);
    setShowRelatorio(false);
  };

  const gerarPDF = () => {
    const titulo = {
      text: "Empresa: " + filtro.nomeEmpresa,
      fontSize: 20,
      bold: true,
      margin: [0, 0, 0, 20],
    };

    const dadosRelatorio = {
      text: [
        { text: "Unidade: ", bold: true },
        filtro.nomeUnidade || "Todas as unidades de " + filtro.nomeEmpresa,
        "\n",
        { text: "Gerado em: ", bold: true },
        dataHora,
      ],
      margin: [0, 0, 0, 20],
    };

    const estiloCabecalho = {
      fontSize: 18,
      bold: true,
      margin: [0, 20, 0, 10],
    };

    const cardStyle = {
      margin: [0, 10],
      border: '1px solid #ccc',
      borderRadius: 10,
      padding: 10,
    };

    const criarTabelaOrdens = (ordens, title) => ({
      stack: [
        { text: title, style: estiloCabecalho },
        {
          table: {
            headerRows: 1,
            widths: ['auto', 'auto'],
            body: [
              [{ text: 'Status', style: 'tableHeader' }, { text: 'Quantidade', style: 'tableHeader' }],
              ...ordens.map(([status, quantidade]) => [status, quantidade]),
            ],
          },
          layout: 'lightHorizontalLines',
          style: 'tableMargin',
        },
      ],
      style: cardStyle,
    });

    const ordensAbertas = [
      ['Em Atraso', dados.data.relatorio.qtdeOrdensAbertasAtrasadas],
      ['Em Dia', dados.data.relatorio.qtdeOrdensAbertasEmDia],
    ];

    const ordensConcluidas = [
      ['Em Atraso', dados.data.relatorio.qtdeOrdensFechadasAtrasadas],
      ['Em Dia', dados.data.relatorio.qtdeOrdensFechadasEmDia],
    ];

    const docDefinition = {
      content: [
        {
          stack: [
            titulo,
            {
              columns: [
                { width: 'auto', text: dadosRelatorio.text },
              ],
            },
            { text: "Equipamentos Ativos: " + dados.data.relatorio.qtdeEquipamentosAtivos, margin: [0, 20, 0, 10] },
          ],
          style: cardStyle,
        },
        criarTabelaOrdens(
          [
            ['Abertas', dados.data.relatorio.totalOrdensAbertas],
            ['Concluídas', dados.data.relatorio.totalOrdensFechadas],
            ['Canceladas', dados.data.relatorio.totalOrdensCanceladas],
          ],
          'Ordens de Serviço'
        ),
        criarTabelaOrdens(ordensAbertas, 'Ordens de Serviço Abertas'),
        criarTabelaOrdens(ordensConcluidas, 'Ordens de Serviço Concluídas'),
      ],
      styles: {
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: 'black',
        },
        tableMargin: {
          margin: [0, 20, 0, 10],
        },
        header: estiloCabecalho,
      },
    };

    pdfMake.createPdf(docDefinition).download("relatorio_inventario.pdf");
  };

  return (
    <Container>
      <button
        onClick={gerarPDF}
        style={{
          position: "fixed",
          bottom: 20,
          right: 20,
          zIndex: 9999,
          backgroundColor: "#DF2E38",
          padding: 20,
          borderRadius: 40,
          border: "none",
          cursor: "pointer",
        }}
      >
        <FaFilePdf size={25} color="white" /> {/* Ícone de PDF */}
      </button>
      <button
        onClick={handleForm}
        style={{
          position: "fixed",
          bottom: 20,
          right: 90,
          zIndex: 9999,
          backgroundColor: "#41B06E",
          padding: 20,
          borderRadius: 40,
          border: "none",
          cursor: "pointer",
        }}
      >
        <FaPlus size={25} color="white" /> {/* Ícone de PDF */}
      </button>
      <button
        onClick={handleGoHome}
        style={{
          position: "fixed",
          bottom: 20,
          right: 160,
          zIndex: 9999,
          backgroundColor: "#B4B4B8",
          padding: 20,
          borderRadius: 40,
          border: "none",
          cursor: "pointer",
        }}
      >
        <FaHome size={25} color="white" /> {/* Ícone de PDF */}
      </button>
      <div className="border border-dark p-3">
        <h3 className="mt-4 mb-3">Empresa: {filtro.nomeEmpresa}</h3>
        <Row>
          <Col>
            <Card>
              <Card.Body>
                <Card.Title>Dados do relatório:</Card.Title>
                <Card.Text>
                  <ul className="list-unstyled">
                    <li>
                      <strong>Unidade:</strong> {filtro.nomeUnidade || "Todas as unidades"}
                    </li>
                    <li>
                      <strong>Gerado em:</strong> {dataHora}
                    </li>
                  </ul>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <Card.Body>
                <Row>
                  <Col>
                    <Card.Title>Equipamentos Ativos:</Card.Title>
                  </Col>
                  <Col>
                    <Card.Text>{dados.data.relatorio.qtdeEquipamentosAtivos}</Card.Text>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <Card>
              <Card.Body>
                <Card.Title>Ordens de Serviço</Card.Title>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Status</th>
                      <th>Quantidade</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Abertas</td>
                      <td>{dados.data.relatorio.totalOrdensAbertas}</td>
                    </tr>
                    <tr>
                      <td>Concluídas</td>
                      <td>{dados.data.relatorio.totalOrdensFechadas}</td>
                    </tr>
                    <tr>
                      <td>Canceladas</td>
                      <td>{dados.data.relatorio.totalOrdensCanceladas}</td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <Card>
              <Card.Body>
                <Card.Title>Ordens de Serviço Abertas</Card.Title>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Status</th>
                      <th>Quantidade</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Em Atraso</td>
                      <td>{dados.data.relatorio.qtdeOrdensAbertasAtrasadas}</td>
                    </tr>
                    <tr>
                      <td>Em dia</td>
                      <td>{dados.data.relatorio.qtdeOrdensAbertasEmDia}</td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card>
              <Card.Body>
                <Card.Title>Ordens de Serviço Concluídas</Card.Title>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Status</th>
                      <th>Quantidade</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Em Atraso</td>
                      <td>{dados.data.relatorio.qtdeOrdensFechadasAtrasadas}</td>
                    </tr>
                    <tr>
                      <td>Em dia</td>
                      <td>{dados.data.relatorio.qtdeOrdensFechadasEmDia}</td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default RelatorioInventarioCliente;
